import { ToastContainer as Toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./style.css";

import { ThemeType } from "theme";

type ToastTheme = "dark" | "light" | "colored";

interface CustomToastProps {
  themeType: ThemeType;
}

const ToastContainer: React.FC<CustomToastProps> = ({ themeType }) => {
  const theme: ToastTheme = themeType === ThemeType.DARK ? "dark" : "light";

  return <Toast theme={theme} autoClose={4000} closeOnClick />;
};

export default ToastContainer;
